import { useEffect } from 'react'

import {
  isJsdWidgetMounted,
  mountJsdWidget,
  startJsdWidget,
  unmountJsdWidget,
} from './supportWidgetUtils'

export default function SupportJsdEmbed({ widgetKey, onReady, onError }) {
  useEffect(() => {
    const script = mountJsdWidget(widgetKey)
    if (!script) {
      onError?.()
      return undefined
    }

    const handleLoad = () => {
      startJsdWidget()
      if (isJsdWidgetMounted()) {
        onReady?.()
        return
      }
      onError?.()
    }

    const handleError = () => onError?.()

    script.addEventListener('load', handleLoad)
    script.addEventListener('error', handleError)

    if (
      script.getAttribute('data-jsd-loaded') === 'true' ||
      script.readyState === 'complete'
    ) {
      handleLoad()
    }

    return () => {
      script.removeEventListener('load', handleLoad)
      script.removeEventListener('error', handleError)
      unmountJsdWidget()
    }
  }, [widgetKey, onReady, onError])

  return null
}
